import React, { useState, useEffect } from "react";
import { Button, Text, Box } from "@chakra-ui/react";

const CooldownButton = ({ onClick, colorScheme = "teal", buttonText = "Click Me", cooldownDuration = 30 }) => {
    const [isCooldown, setIsCooldown] = useState(false);
    const [cooldownTime, setCooldownTime] = useState(0);

    const handleClick = () => {
        if (!isCooldown) {
            onClick(); // Trigger the passed onClick function
            setIsCooldown(true);
            setCooldownTime(cooldownDuration); // Use cooldownDuration prop
        }
    };

    useEffect(() => {
        let timer;

        if (isCooldown) {
            timer = setInterval(() => {
                setCooldownTime((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsCooldown(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000); // Update every second
        }

        return () => clearInterval(timer); // Cleanup interval on component unmount
    }, [isCooldown]);

    return (
        <Box textAlign="center" w="100%">
            <Button
                w="100%"
                colorScheme={colorScheme}
                isDisabled={isCooldown}
                onClick={handleClick}
            >
                {isCooldown ? `Cooldown: ${cooldownTime}s` : buttonText}
            </Button>
            {isCooldown && (
                <Text fontSize="sm" color="gray.500">
                    You can click the button again after the cooldown ends.
                </Text>
            )}
        </Box>
    );
};

export default CooldownButton;
